module.exports = __webpack_public_path__ + "static/media/logo-horizontalG-02.eebd3da6.svg";